import React from 'react';
import moment from 'moment';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import cn from 'classnames';
import i18n from '../../../config/i18n';

const DatePicker = ({
  placeholder,
  onChange,
  value,
  showIcon,
  readOnlyInput,
  minDate,
  maxDate,
  showClearIcon,
  timeOnly,
  showTime,
  dateFormat = 'DD/MM/YYYY',
  displayFormat = 'dd M, yy',
  hourFormat,
  ...restProps
}) => {
  let format = dateFormat;
  // Only append time format if showTime is true and NOT timeOnly
  // When timeOnly is true, dateFormat should already contain the time format
  if (showTime && !timeOnly) {
    // Use HH for 24-hour format, hh for 12-hour format
    const timeFormat = hourFormat === 24 ? 'HH:mm:ss' : 'hh:mm:ss';
    format += ' ' + timeFormat;
  }
  const handleChange = (e) => {
    const formattedDate = moment(e.target.value).format(format);
    onChange(formattedDate);
  };

  const minDateObj = minDate ? moment(minDate, format).toDate() : null;
  const maxDateObj = maxDate ? moment(maxDate, format).toDate() : null;
  const valueObj = value ? moment(value, format).toDate() : null;

  // Determine the display format for PrimeReact Calendar
  // When timeOnly, don't set a date format
  const calendarDateFormat = timeOnly ? undefined : displayFormat;

  // Prepare calendar props, only including hourFormat if it's defined
  const calendarProps = {
    placeholder,
    showIcon,
    readOnlyInput,
    value: valueObj,
    minDate: minDateObj,
    maxDate: maxDateObj,
    onChange: handleChange,
    timeOnly,
    showTime,
    dateFormat: calendarDateFormat,
    ...restProps,
  };

  // Only add hourFormat if it's explicitly provided
  if (hourFormat !== undefined) {
    calendarProps.hourFormat = hourFormat;
  }

  return (
    <div className={cn('d-flex calendar-field', calendarProps.className)}>
      <Calendar {...calendarProps} locale={i18n.language} />
      {showClearIcon && (
        <Button
          icon="pi pi-times"
          type="button"
          text
          onClick={() => {
            onChange('');
          }}
        />
      )}
    </div>
  );
};

export default React.memo(DatePicker);
